import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '../../core/Icon';
import Form from '../../form/field';

var Search = function Search(_ref) {
  var defaultFilter = _ref.defaultFilter,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      variant = _ref.variant;

  var _React$useState = React.useState(!!defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      opened = _React$useState2[0],
      toggle = _React$useState2[1];
  /** Improvement: based on defaultValue deduce defaultFilter, e.g. completed: John */


  var defaultTextValue = defaultValue;
  var defaultTextFilter = defaultFilter;

  if (opened) {
    return React.createElement(Form.Input.Text, {
      autoFocus: true,
      placeholder: "Search...",
      defaultValue: defaultTextValue,
      variant: "standard",
      InputProps: {
        endAdornment: React.createElement(InputAdornment, {
          position: "end"
        }, React.createElement(Icon, {
          hoverable: true,
          buttonSize: "small",
          label: "Clear text search",
          tooltipPlacement: "right",
          type: "close",
          onClick: function onClick() {
            onChange({
              filter: defaultTextFilter,
              value: ''
            });
            toggle(false);
          },
          style: {
            fontSize: '1rem'
          }
        }))
      },
      onBlur: function onBlur(e) {
        if (!e.target.value) {
          toggle(false);
          return;
        }
      },
      onEscape: function onEscape() {
        toggle(false);
      },
      onEnter: function onEnter(e) {
        //IMPROVEMENT: set filter according to text e.g. 'rejected: John'
        onChange({
          filter: defaultTextFilter,
          value: e.target.value
        });
      }
    });
  }

  return React.createElement(Icon, {
    buttonSize: "small",
    type: "search",
    hoverable: true,
    label: "Search",
    tooltipPlacement: "right",
    style: {
      fontSize: variant === 'h5' ? '1.3rem' : '1.1rem',
      minHeight: 8 * 4,
      minWidth: 8 * 4
    },
    onClick: function onClick() {
      return toggle(true);
    }
  });
};

export default Search;